"use client";
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { country } from "../../constant/country";
import { createPartnerLeadInZoho } from "@/action/zoho";
import { trackEvent } from "@/utils/tracking";

const ConsultationForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Treatment: "",
    Country: "India",
    CountryCode: "+91",
    Mobile: "",
    City: "",
    Description: "",
    Age: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      trackEvent("consultation_form",{
        page: window.location.pathname,
        country: formData.Country,
        treatment: formData.Treatment,
      });
      // Submit to Zoho
      const zohoResponse = await createPartnerLeadInZoho({
        First_Name: formData.Name,
        Email: formData.Email,
        Treatment: formData.Treatment,
        Country: formData.Country,
        Phone: formData.Mobile,
        City: formData.City,
        Description: formData.Description,
        Age: formData.Age,
        Mobile_Country_Code: formData.CountryCode,
      });
      if (zohoResponse) {
        setFormData({
          Name: "",
          Email: "",
          Treatment: "",
          Country: "India",
          CountryCode: "+91",
          Mobile: "",
          City: "",
          Description: "",
          Age: "",
        });
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="w-full max-w-[560px] min-h-[600px] mt-4 sm:mt-0 mx-auto bg-white border border-[#E4E8FF] rounded-lg p-6 sm:p-8 flex flex-col shadow-sm">
      <h2 className="font-poppins font-semibold text-base sm:text-lg leading-[25px] tracking-[0.04em] text-center text-[#006DAF] mb-6 sm:mb-8">
        Get in Touch with Our Medical Experts
      </h2>

      <div className="space-y-5 w-full max-w-[400px] mx-auto flex-1">
        <div>
          <Input
            label="Patient's Full Name"
            className="w-full h-10 px-4 rounded-xl border-[#E4E8FF] placeholder-gray-400 bg-white
              xl:h-11 xl:px-5
              lg:h-10 lg:px-4
              md:h-9 md:px-3
              sm:h-8 sm:px-3
              h-8 px-2"
            placeholder="Patient's Full Name"
            value={formData.Name}
            onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
            style={{ borderWidth: "1px" }}
          />
        </div>

        {/* <div>
          <Input
            className="w-full h-10 px-4 rounded-xl border-[#E4E8FF] placeholder-gray-400 bg-white"
            placeholder="Enter Your Email-ID"
            type="email"
            value={formData.Email}
            onChange={(e) =>
              setFormData({ ...formData, Email: e.target.value })
            }
          />
        </div> */}

        <div>
          <Select
            value={formData.Country}
            placeholder="Your Current Country"
            onValueChange={(val) => {
              const selectedCountry = country.find((c) => c.name === val);
              setFormData({
                ...formData,
                Country: val,
                CountryCode: selectedCountry?.dial_code || "+91",
              });
            }}
          >
            <SelectTrigger className="w-full h-10 px-4 rounded-xl border-[#E4E8FF] bg-white
              xl:h-11 xl:px-5
              lg:h-10 lg:px-4
              md:h-9 md:px-3
              sm:h-8 sm:px-3
              h-8 px-2">
              <SelectValue placeholder="Your Country" />
            </SelectTrigger>
            <SelectContent>
              {country.map((c) => (
                <SelectItem key={c.name} value={c.name}>
                  {c.flag} {c.name} ({c.dial_code})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* <div>
          <Input
            className="w-full h-10 px-4 rounded-xl border-[#E4E8FF] placeholder-gray-400 bg-white"
            placeholder="City"
            value={formData.City}
            onChange={(e) => setFormData({ ...formData, City: e.target.value })}
          />
        </div> */}

        <div className="flex gap-3 w-full sm:flex-row flex-col">
          <div className="sm:w-20 w-full h-10 flex items-center justify-center bg-white rounded-xl border border-[#E4E8FF] text-sm font-medium">
            {formData.CountryCode}
          </div>
          <Input
            label="Your Mobile Number"
            className="flex-1 h-10 px-4 rounded-xl border-[#E4E8FF] placeholder-gray-400 bg-white"
            placeholder="Your Mobile Number"
            value={formData.Mobile}
            onChange={(e) =>
              setFormData({ ...formData, Mobile: e.target.value })
            }
            style={{ borderWidth: "1px" }}
          />

        </div>
        <div>
          <Input
            className="w-full h-10 px-4 rounded-xl border-[#E4E8FF] placeholder-gray-400 bg-white"
            placeholder="Patient's Age"
            value={formData.Age}
            onChange={(e) => setFormData({ ...formData, Age: e.target.value })}
            style={{ borderWidth: "1px" }}
          />
        </div>


        <div>
          <Textarea
            className="w-full h-[97px] p-4 rounded-xl border-[#E4E8FF] placeholder-gray-400 bg-white resize-none"
            placeholder="Describe the Patient's Medical Condition"
            value={formData.Description}
            onChange={(e) =>
              setFormData({ ...formData, Description: e.target.value })
            }
            style={{ borderWidth: "1px" }}
          />
        </div>

        <div className="space-y-4 mt-6">
          <Button
            className="w-full h-[50px] bg-[#006DAF] hover:bg-[#005c94] text-white text-lg font-semibold rounded-xl transition-colors duration-200"
            onClick={handleSubmit}
          >
            Chat Now
          </Button>

          <p className="text-center text-gray-500 text-sm">
            Get First Response Within 4hrs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConsultationForm;
